module.exports = __webpack_public_path__ + "img/image-icon.8435d5d.png";